module.exports = __webpack_public_path__ + "img/wxp.07573533.png";